<template>
  <div class="credit-card-brands">
    <Visa />
    <Mastercard />
    <Jcb />
    <AmericanExpress />
    <DinersClub />
  </div>
</template>

<script setup>
import Visa from '../../atoms/svg_icons/credit_card_brands/Visa.vue'
import Mastercard from '../../atoms/svg_icons/credit_card_brands/Mastercard.vue'
import Jcb from '../../atoms/svg_icons/credit_card_brands/Jcb.vue'
import AmericanExpress from '../../atoms/svg_icons/credit_card_brands/AmericanExpress.vue'
import DinersClub from '../../atoms/svg_icons/credit_card_brands/DinersClub.vue'
</script>

<style lang="scss" scoped>
.credit-card-brands {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;

  @media screen and (max-width: $small-contents-width) {
    & > * {
      width: 20%; // ブランドの数が5つなので、100% / 5 = 20%
      height: auto;
    }
  }
}
</style>
